import {
  THEME_MODES,
  STORAGE_KEY,
  DARK_DISPLAY,
  getStoredThemeMode,
  resolveIsDark,
  applyCssThemeVariables,
  applyDocumentThemeClass,
  applyVuetifyTheme,
} from '../helpers/themeMode';

const storedUser = localStorage.getItem('user');
let initialPrimary = '#f87676';
let initialButton = '#30384d';

if (storedUser) {
  try {
    const user = JSON.parse(storedUser);
    if (user.theme_primary_color) initialPrimary = user.theme_primary_color;
    if (user.theme_button_color) initialButton = user.theme_button_color;
  } catch (e) {
    console.error('Failed to parse stored user theme', e);
  }
}

const initialThemeMode = getStoredThemeMode();
const initialIsDark = resolveIsDark(initialThemeMode);

const state = {
  savedPrimaryColor: initialPrimary,
  savedButtonColor: initialButton,
  primaryColor: initialIsDark ? DARK_DISPLAY.accent : initialPrimary,
  buttonColor: initialIsDark ? DARK_DISPLAY.button : initialButton,
  themeMode: initialThemeMode,
  isDark: initialIsDark,
};

const getters = {
  headerColor(state) {
    return state.isDark ? DARK_DISPLAY.header : state.savedPrimaryColor;
  },
};

const mutations = {
  setPrimaryColor(state, data) {
    state.savedPrimaryColor = data.primaryColor;
    if (!state.isDark) {
      state.primaryColor = data.primaryColor;
    }
  },
  setButtonColor(state, data) {
    state.savedButtonColor = data.buttonColor;
    if (!state.isDark) {
      state.buttonColor = data.buttonColor;
    }
  },
  setThemeMode(state, mode) {
    state.themeMode = mode;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      console.error('Failed to persist theme mode', e);
    }
  },
  setDarkMode(state, isDark) {
    state.isDark = isDark;
    if (isDark) {
      state.primaryColor = DARK_DISPLAY.accent;
      state.buttonColor = DARK_DISPLAY.button;
      return;
    }
    state.primaryColor = state.savedPrimaryColor;
    state.buttonColor = state.savedButtonColor;
  },
  resetTheme(state) {
    state.savedPrimaryColor = '#f87676';
    state.savedButtonColor = '#30384d';
    state.primaryColor = state.isDark ? DARK_DISPLAY.accent : '#f87676';
    state.buttonColor = state.isDark ? DARK_DISPLAY.button : '#30384d';
  },
};

const actions = {
  applyAppearance({ state, commit }, { vuetify } = {}) {
    const isDark = resolveIsDark(state.themeMode);
    commit('setDarkMode', isDark);
    applyDocumentThemeClass(isDark);
    applyVuetifyTheme(vuetify, {
      isDark,
      primaryColor: state.savedPrimaryColor,
      buttonColor: state.savedButtonColor,
    });
    applyCssThemeVariables({
      isDark,
      primaryColor: state.savedPrimaryColor,
      buttonColor: state.savedButtonColor,
    });
  },

  setThemeMode({ commit, dispatch }, { mode, vuetify }) {
    commit('setThemeMode', mode);
    dispatch('applyAppearance', { vuetify });
  },

  initThemeListener({ state, dispatch }) {
    if (typeof window === 'undefined') return;

    if (window.__societyThemeMediaQuery) {
      window.__societyThemeMediaQuery.removeEventListener(
        'change',
        window.__societyThemeMediaHandler,
      );
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      if (state.themeMode === THEME_MODES.SYSTEM) {
        dispatch('applyAppearance', { vuetify: window.__societyVuetify });
      }
    };

    mediaQuery.addEventListener('change', handler);
    window.__societyThemeMediaQuery = mediaQuery;
    window.__societyThemeMediaHandler = handler;
  },
};

export { THEME_MODES };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
